import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { StructureType } from '__generated__/api';

export const getStructureTypesInput = (searchCriteria: SearchCriteriaModel): StructureType[] | null => {
  if (searchCriteria.lodging && searchCriteria.lodging.length > 0) {
    return searchCriteria.lodging
      .map(type => {
        const result = StructureType[StructureType[type]];

        return result ? result : null;
      })
      .filter(type => type !== null);
  }

  return null;
};
